import * as React from 'react'
import { NetworkStatus } from '@apollo/client'
import { isEmpty } from 'lodash'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import { Loader } from '~/components'
import Label from '~/truck/label'
import type { IProduct } from '~/types/products'

import { EmptyStateContent } from './empty-state-content'

export interface ContentLayoutProps {
  dataSource?: IProduct[]
  render: () => React.ReactElement
  networkStatus: NetworkStatus
}

const Container = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: calc(100vh - ${props => props.theme.spacing.cozy * 38}px);
  padding: ${props => props.theme.spacing.cozy * 3}px;
  width: 100%;

  ${up('lg')} {
    min-height: calc(100vh - ${props => props.theme.spacing.cozy * 44}px);
  }
`

export function ContentLayout(props: ContentLayoutProps) {
  const { networkStatus, render, dataSource } = props

  if (networkStatus === NetworkStatus.loading) {
    return (
      <Container>
        <Loader />
      </Container>
    )
  }

  if (networkStatus === NetworkStatus.error) {
    return (
      <Container>
        <Label as="p" $textStyle="h5Regular">
          Hubo un problema inesperado.
        </Label>
      </Container>
    )
  }

  if (isEmpty(dataSource)) {
    return (
      <Container>
        <EmptyStateContent />
      </Container>
    )
  }

  return render()
}
